import ko from 'knockout';

export class ViewModel {
  constructor(options) {
    this.mobileUrlVisible = ko.observable(options.isFinal && !options.isMobilePreferred);
    this.showTitles = ko.observable(options.showTitles);
    this.errorMessages = ko.observableArray();
    this.landingPageUrlErrorMessages = ko.observableArray();
    this.showUpgradeWarning = ko.observable(false);
  }
}
